export default {
  BUILDER_ADD_PAGE: 50001,
  BUILDER_DOMAIN: 5002,
  BUILDER_UPDATE_DOMAIN: 5003,
  BUILDER_ADD_AND_UPDATE_YOUR_DOMAIN: 5004,
  ADD_CODE_TO_WEBSITE: 5005,
  DUPLICATE_SECTION: 5006
}
